// Recommended paths are stored lesson-keyed but rendered per-topic. The
// server returns `video_primary_topic` (with `video_topic_map` as a
// secondary signal) so the client can derive the topic-scoped slice
// without an extra fetch.
export function filterRecommendedPathByTopic(recommendedPath, topicId) {
    if (!recommendedPath || !topicId) {
        return recommendedPath;
    }
    const primaryMap = recommendedPath.video_primary_topic || {};
    const topicMap = recommendedPath.video_topic_map || {};
    if (
        Object.keys(primaryMap).length === 0 &&
        Object.keys(topicMap).length === 0
    ) {
        return recommendedPath;
    }

    // A video belongs to exactly one topic's slice — its primary. The
    // backend per-topic floor is responsible for giving every concept-bearing
    // topic its own distinct primary; falling back to `video_topic_map` is
    // only used when a candidate has no primary at all.
    const matches = (videoId) => {
        const primary = primaryMap[videoId];
        if (primary != null) {
            return primary === topicId;
        }
        const topics = topicMap[videoId];
        return Array.isArray(topics) && topics.includes(topicId);
    };

    const filtered = (recommendedPath.recommended_videos || []).filter((v) =>
        matches(v?.video_id),
    );
    const remaining = filtered.filter((v) => (v?.progress || 0) < 100).length;

    return {
        ...recommendedPath,
        recommended_videos: filtered,
        num_videos: filtered.length,
        remaining_count: remaining,
    };
}
